import Vue from 'vue'
import App from '@/App.vue'

import router from '@/router'
import '@mock'

// buefy
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import '@mdi/font/css/materialdesignicons.css'

import '@/libs/leaflet'
import '@/libs/leaflet-plugins/fullscreen'
import '@/libs/leaflet-plugins/fullscreen/index.css'

import '@/assets/scss/_style.scss'


import store from '@/store'

Vue.use(Buefy)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
